var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"no-gutters"},[_c('b-col',{staticClass:"col-12 col-md-8 col-lg-6"},[_c('h4',{staticClass:"font-weight-normal text-muted title__2 mb-4"},[_vm._v(" "+_vm._s(_vm.$t("page.review.title"))+" ")]),_c(_vm.activeComponent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }